export default __webpack_public_path__ + "images/40ac3313e49a28e3d85a3aebff895819-business.jpg";